import React, { useState } from "react"
import { Modal } from "react-bootstrap"

import { moment } from "utils"
import DpDates from "./DpDates"
import DpMonths from "./DpMonths"
import DpYears from "./DpYears"
import DpTimePicker from "./DpTimePicker"
import DpFooter from "./DpFooter"
import DpHeader from "./DpHeader"
import classes from "./index.module.scss"



const initialSelectedTimeState = {
  hours: "00",
  minutes: "00"
}

const initialTimeRangeState = [
  { hours: "00", minutes: "00" },
  { hours: "00", minutes: "00" }
]

const DatePicker = props => {
  const {
    type = "datePicker",
    openDatePicker = false,
    setOpenDatePicker = () => { },
    disabled = false,
    minDate,
    maxDate,
    range = [],
    value,
    onChange
  } = props

  const m = moment()

  const [shownDate, setShownDate] = useState(m)
  const [selectedRange, setSelectedRange] = useState([])
  const [selectedDate, setSelectedDate] = useState(m)
  const [selectedTime, setSelectedTime] = useState(initialSelectedTimeState)
  const [content, setContent] = useState("days")
  const [timeRangeStep, setTimeRangeStep] = useState("start")
  const [timeRange, setTimeRange] = useState(initialTimeRangeState)

  const handleExited = () => {
    const initialContent =
      type === "rangeTimePicker" ? "time" :
        type === "timePicker" ? "time" : "days"

    setContent(initialContent)
    setTimeRangeStep("start")
    setTimeRange(initialTimeRangeState)
    setSelectedRange([])
  }

  const handleEnter = () => {
    const initialContent =
      type === "rangeTimePicker" ? "time" :
        type === "timePicker" ? "time" : "days"

    setContent(initialContent)

    if (type === "timePicker" && !!value) {
      setSelectedTime({
        hours: value.split(":")[0],
        minutes: value.split(":")[1]
      })

      return
    }

    if (type === "datePicker" && !!value) {
      setShownDate(moment(value))
      setSelectedDate(moment(value))
      return
    }

    if (type === "dateAndTimePicker" && !!value) {
      setShownDate(moment(value))
      setSelectedDate(moment(value))
      setSelectedTime({
        hours: moment(value).get("hours"),
        minutes: moment(value).get("minutes")
      })

      return
    }

    if (type === "rangeDatePicker" && !!range[0]) {
      setSelectedRange([moment(range[0]), moment(range[1])])
      setShownDate(moment(range[1]))
      return
    }

    if (type === "rangeTimePicker" && !!range[0]) {
      setTimeRange([
        {
          hours: range[0].split(":")[0],
          minutes: range[0].split(":")[1]
        },
        {
          hours: range[1].split(":")[0],
          minutes: range[1].split(":")[1]
        }
      ])

      return
    }
  }

  return (
    <Modal
      centered
      backdrop="static"
      show={!disabled && openDatePicker}
      onHide={() => setOpenDatePicker(false)}
      dialogClassName={classes["dialog"]}
      contentClassName={classes["content"]}
      onEnter={handleEnter}
      onExited={handleExited}
    >
      <DpHeader
        type={type}
        shownDate={shownDate}
        selectedRange={selectedRange}
        selectedTime={selectedTime}
        selectedDate={selectedDate}
        setContent={setContent}
        timeRange={timeRange}
      />
      <div className={classes["body"]}>
        {
          content === "days" &&
          <DpDates
            type={type}
            minDate={minDate}
            maxDate={maxDate}
            selectedRange={selectedRange}
            setSelectedRange={setSelectedRange}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            shownDate={shownDate}
            setShownDate={setShownDate}
            setContent={setContent}
            setSelectedTime={setSelectedTime}
          />
        }
        {
          content === "months" &&
          <DpMonths
            minDate={minDate}
            maxDate={maxDate}
            shownDate={shownDate}
            setShownDate={setShownDate}
            setContent={setContent}
          />
        }
        {
          content === "years" &&
          <DpYears
            minDate={minDate}
            maxDate={maxDate}
            shownDate={shownDate}
            setShownDate={setShownDate}
            setContent={setContent}
          />
        }
        {
          content === "time" &&
          <DpTimePicker
            type={type}
            timeRange={timeRange}
            setTimeRange={setTimeRange}
            timeRangeStep={timeRangeStep}
            setTimeRangeStep={setTimeRangeStep}
            setSelectedDate={setSelectedDate}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            setContent={setContent}
          />
        }
      </div>
      <DpFooter
        type={type}
        onChange={onChange}
        selectedTime={selectedTime}
        timeRange={timeRange}
        setTimeRange={setTimeRange}
        timeRangeStep={timeRangeStep}
        setTimeRangeStep={setTimeRangeStep}
        selectedDate={selectedDate}
        setSelectedTime={setSelectedTime}
        setSelectedDate={setSelectedDate}
        setOpenDatePicker={setOpenDatePicker}
        selectedRange={selectedRange}
        setSelectedRange={setSelectedRange}
        setShownDate={setShownDate}
      />
    </Modal>
  )
}

export default DatePicker